import TransactionDetails from 'features/accounts/TransactionDetails/TransactionDetails';
import React from 'react';

export default function ExternalTransactionDetails() {
  return <TransactionDetails />;
}
